import axios from 'axios';

export const startRecording = async (store, examGroupId) => {
    if(examGroupId== store.state.examId && store.state.stopFn){
        //we are already recording for this exam
        return;
    }
    //uploadAnyOldRecording
    uploadRecording(store);
    store.commit('stopRecording');
    store.commit('setExamGroupId', examGroupId);
    store.commit('startRecording');
}

export const stopRecording = async (store) => {
    //uploadAnyOldRecording
    uploadRecording(store);
}

export const uploadRecording = async (store) => {
    store.commit('stopRecording');
    const events = store.state.events;
    const examGroupId = store.state.examGroupId;
    if (!events || events.length === 0 || !examGroupId) {
        return;
    }

    try {
        // Convert events array to a Blob (JSON file)
        const eventsBlob = new Blob([JSON.stringify(events)], { type: "application/json" });

        // Create FormData object
        const formData = new FormData();
        formData.append("file", eventsBlob, examGroupId + ".json");
        store.commit('setExamGroupId', undefined);
        // Send the FormData to your REST endpoint
        axios.post(process.env.VUE_APP_ROOT_API + "uploadExamRecording", formData, {
            headers: {
                "Content-Type": "multipart/form-data", // Ensure multipart encoding
            },
        });

    } catch (error) {
        console.log(error);
    }
};
